
import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "../../../components/Component";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import "src/pages/home/signUp-pages/style.css";
import { AppContextConsumer, IAppContext } from "src/components/withAppContext";
import { withRouter } from "react-router-dom";
import LoadingSpinner from "src/components/LoadingSpinner";
import Headerpage from "src/components/header";
import Footerpage from "src/components/footer";
// import ArrowIcon from "src/assets/Arrow.png";
// import LoadingSpinner from "src/components/LoadingSpinner";
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box } from '@material-ui/core/';
// import { Edit } from '@material-ui/icons-material';
const styles = () => ({
      childTemplate: {
            paddingLeft: 80,
      },
      listItem: {
            "&:hover": {
                  backgroundColor: "#e6e6e6",
            },
            backgroundColor: "white",
      },
});

type IProps = IAxiosProps & IAppContext &
      WithStyles<keyof ReturnType<typeof styles>> & { history: any };

interface ITemplatesPageState {
      subscriptionPlan: any,
      loader: boolean;
      redirectAddon: boolean
      activeContainer: any,
      getAllAddonData: any

}

const Home = withStyles(styles)(
      withAxios(
            class PricePage extends Component<IProps, ITemplatesPageState> {
                  public state = this.buildState({
                        subscriptionPlan: {},
                        loader: false,
                        redirectAddon: false,
                        activeContainer: [],
                        getAllAddonData: []
                  });
                  public componentWillMount(): void {
                        this.props.getNewLoginUserDetails()
                  }
                  public componentDidMount() {
                        if (this.props.newUserDetails?.subscriptionPlan != null && this.props.newUserDetails?.subscriptionPlan && Object.keys(this.props.newUserDetails?.subscriptionPlan).length > 0) {
                              this.setState({ subscriptionPlan: this.props.newUserDetails?.subscriptionPlan }, () => {
                                    this.getAllAddonHandler()
                              })
                        }
                        if (this.props.newUserDetails?.addonPlan) {
                              if (this.props.newUserDetails?.addonPlan.length > 0) {
                                    this.setState({ activeContainer: this.props.newUserDetails?.addonPlan })
                              }
                        }

                  }

                  public toggleContainer(id: number) {
                        // this.setState({ activeContainer: containerId === this.state.activeContainer ? null : containerId });
                        this.setState((prevState: any) => {
                              const { activeContainer } = prevState;

                              if (activeContainer.length > 0 && activeContainer.includes(id)) {
                                    // If the id is already in the array, remove it
                                    return { activeContainer: activeContainer.filter((itemId: any) => itemId !== id) };
                              } else {
                                    // If the id is not in the array, add it
                                    return { activeContainer: [...activeContainer, id] };
                              }
                        });
                  }

                  public planIDgets() {
                        switch (this.state.subscriptionPlan.id) {
                              case 2:
                                    return [1, 2, 3, 4]
                              case 3:
                                    return [2, 3, 4]
                              case 4:
                                    return [3, 4]
                              case 5:
                                  return [4]
                              default:
                                    return []
                        }
                  }
                  public async getAllAddonHandler() {
                        this.setState({ loader: true })
                        const res: any = await this.buildGet(this, "payment/getAddonPlan")()
                        if (res.status && res?.data?.length > 0) {
                              console.log("res.data=======>", res.data)
                              // const data = res.data.find((itm:any)=>this.state.subscriptionPlan.id===itm.id)
                              // console.log("data=========>",data)
                              const planAddon: any = []

                              if (res?.data?.length > 0) {
                                    res.data.map((item: any) => {
                                          if (this.planIDgets().includes(item.id)) {
                                                planAddon.push(item)
                                          }
                                    })
                              }
                              const data = planAddon.sort((a: any, b: any) => a.id - b.id);
                              this.setState({ getAllAddonData: data })
                              this.setState({ loader: false })
                        } else {
                              this.setState({ loader: false })
                        }
                        // this.setState({ user: res })
                  }

                  public NextHandler() {
                        const tempData: any = []
                        if (this.state.activeContainer?.length > 0) {

                              this.state.getAllAddonData.map((item: any) => {
                                    if (this.state.activeContainer.includes(item.id)) {
                                          tempData.push(item)
                                    }

                              })

                              // getAllAddonData
                        }
                        this.props.onChangeUserDetails({
                              ...this.props?.newUserDetails,
                              addonPlan: this.state.activeContainer,
                              addonPlanDetails: tempData
                        });
                        this.props.history.push('/purchase')
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                  }


                  public render() {
                        const { activeContainer, subscriptionPlan } = this.state
                        return (
                              <>
                                <div className="contat-main-bg-color">
                                    {this.state.loader && <div className="loader-bg-color">
                                          <LoadingSpinner /></div>}
                                    <div>
                                          <div className="starter-container">
                                             <Headerpage/>
                                                <div className="">
                                                      <div className="content">
                                                            <div className="starter-plan">
                                                                  <h3>You selected the <span>{subscriptionPlan?.title} plan.</span> <br />
                                                                        Would you like to add on some of our favorite plan enhancements?
                                                                  </h3>
                                                            </div>


                                                            <div className="row start-flex">
                                                                  {
                                                                        this.state.getAllAddonData.length > 0 && this.state.getAllAddonData?.map((item: any) => {
                                                                              return (
                                                                                    <div className="col-lg-3" key={item?.id}>
                                                                                          <div
                                                                                                className={`customize ${activeContainer?.includes(item?.id) ? 'active' : ''}`}
                                                                                                

                                                                                                onClick={ () => this.toggleContainer(item.id) }
                                                                                                >
                                                                                                <div className="customize-content">
                                                                                                      <h2>{item.title}</h2>
                                                                                                      
                                                                                                      <p className="custo-parag"><br/> {item?.description} </p>

                                                                                                </div>
                                                                                                <div className="custom-div">
                                                                                                      <button className="custom-btn">${item?.price}/{item?.payment_frequency_type}</button>
                                                                                                </div>
                                                                                          </div>
                                                                                    </div>
                                                                              )
                                                                        })
                                                                  }



                                                              
                                                            </div>
                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                  <div className="button-next" style={{ marginRight: 20 }}>
                                                                        <button className="sign-btn" onClick={() => {
                                                                              this.props.history.goBack();
                                                                        }}><span className="next-span-btn">PREV</span></button>
                                                                  </div>
                                                                  <div className="button-next">
                                                                        <button className="sign-btn" onClick={() => {
                                                                              this.NextHandler()
                                                                        }}><span className="next-span-btn">NEXT</span></button>
                                                                  </div>
                                                            </div>

                                                            <div className="next-btn">
                                                                  <button className="no-thanks" onClick={() => {
                                                                        this.setState({ activeContainer: [] }, () => {
                                                                              this.NextHandler()
                                                                        })

                                                                  }}><span>NO THANKS</span></button>
                                                            </div>
                                                      </div>




                                                </div>

                                          </div>
<Footerpage/>
                                    </div>
                                    </div>
                              </>
                        );
                  }
            }
      )
);



const HomeFunction = (props: any) => (
      <AppContextConsumer>{(context) => <Home {...context} history={props?.history} />}</AppContextConsumer>
);
export default withRouter(HomeFunction);





// WEBPACK FOOTER //
// ./src/pages/director/price/starter.tsx